module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ListingCard"
  }, [_c('p', {
    staticClass: "ListingCard-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('a', {
    staticClass: "ListingCard-title",
    attrs: {
      "href": _vm.path
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title)), _c('icon', {
    attrs: {
      "icon": "go-arrow"
    }
  })], 1), _vm._v(" "), (!!_vm.meta) ? _c('p', {
    staticClass: "ListingCard-meta"
  }, [_vm._v(_vm._s(_vm.meta))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "ListingCard-link",
    attrs: {
      "href": _vm.path,
      "aria-hidden": "true",
      "tabindex": "-1"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20d01bf7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/database-search/result.vue
// module id = 323
// module chunks = 0